import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {CfgTaskConfigurationModel} from '../../../models/configuration/cfg-task-configuration.model';
import {CfgTaskConfigurationListModel} from '../../../models/configuration/cfg-task-configuration-list.model';
import {OrganizationDataModel} from '../../../models/organization/organization-data.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {CfgTaskTypeAutodestinationModel} from '../../../models/configuration/cfg-task-type-autodestination.model';

@Injectable({
  providedIn: 'root'
})
export class TaskTypeConfigurationService {
  constructor(private http: HttpClient) {
  }

  getClients(): Observable<any[]> {
    let url: string;
    const method: string = 'task-type-configuration/tdo-clients';
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getClientLocations(tdocid: string): Observable<any[]> {
    let url: string;
    const method: string = 'task-type-configuration/tdo-clients-locations/' + tdocid;
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getLocationTaskTypes(locid: string): Observable<CfgTaskConfigurationListModel[]> {
    let url: string;
    const method: string = 'task-type-configuration/location-task-types/' + locid;
    url = environment.TDOurl + method;
    return this.http.get<CfgTaskConfigurationListModel[]>(url);
  }

  saveTaskType(taskType: CfgTaskConfigurationListModel): Observable<CfgTaskConfigurationListModel> {
    return this.http.post<CfgTaskConfigurationListModel>('/api/task-type-configuration/save-task-type/', taskType);
  }

  removeTaskType(taskType: CfgTaskConfigurationListModel): Observable<CfgTaskConfigurationListModel> {
    return this.http.post<CfgTaskConfigurationListModel>('/api/task-type-configuration/remove-task-type/', taskType);
  }

  removeTaskAutoDestinationType(dest: CfgTaskTypeAutodestinationModel) {
    return this.http.post<void>('api/task-type-configuration/remove-destination', dest);
  }

  getEnumValidValueItemsByValidValueName(ValidValueName: string): Observable<EnumValidValueItemModel[]> {
    return this.http.get<EnumValidValueItemModel[]>(`/api/accountReceivable/getEnumValidValueItemsByValidValueName/${ValidValueName}`);
  }
}
